import { render, staticRenderFns } from "./content_main_list_expandtable.vue?vue&type=template&id=64ab393e&scoped=true&"
import script from "./content_main_list_expandtable.vue?vue&type=script&lang=js&"
export * from "./content_main_list_expandtable.vue?vue&type=script&lang=js&"
import style0 from "./content_main_list_expandtable.vue?vue&type=style&index=0&id=64ab393e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab393e",
  null
  
)

export default component.exports